import React, { useState, useEffect } from "react";

import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import { motion } from "framer-motion";

import lightingImg from "../../../assets/images/sbs/lighting.png";
import triviaSubmit from "../../../assets/images/sbs/sbs-logo-submit.png";
import sadfaceIcon from "../../../assets/images/sbs/sad-face.png";
import img100 from "../../../assets/images/sbs/100+.png";
import ltGlobalLogo from "../../../assets/images/sbs/lt-global-logo.png";
import img75 from "../../../assets/images/sbs/75+.png";
import LeaderBoard from "../lightingTrivia/LeaderBoard";
import pasueIcon from "../../../assets/images/sbs/pause-icon.png";
import nextIcon from "../../../assets/images/sbs/next-icon.png";
import playIcon from "../../../assets/images/sbs/play-icon.png";
import dummyAvatar from "../../../assets/images/sbs/dummyAvatar.png";

import cx from "classnames";

// src={
//   guesserData[0]?.profile_image
//     ? guesserData[0]?.profile_image
//     : dummyAvatar
// }

// import LeaderBoard from "./LeaderBoard";

//otherWinnersUserData

const LtOver = (props) => {
  console.log(editions_LT, "editions_LTeditions_LTeditions_LT");
  const roomData = _.get(props, "gameReducer.roomObj");
  const editions_LT = _.get(roomData, "game_state.question.edition");
  const top_logo = _.get(roomData, "game_state.top_logo");

  const lt_Question = _.get(roomData, "game_state.question.question");
  const correct_answer_number = _.get(
    roomData,
    "game_state.question.correct_answer"
  );
  const correct_answer =
    roomData.game_state?.question?.answers[correct_answer_number];
  //className="text-center sbs-width"
  const [countdownOver, setCountdownOver] = useState(10);
  const [countdownAnimation, setCountdownAnimation] = useState(100);
  const [countdownPaused, setCountdownPaused] = useState(false);
  let timer;
  let timerr;

  useEffect(() => {
    !countdownPaused &&
      countdownOver > 0 &&
      (timer = setInterval(() => setCountdownOver(countdownOver - 1), 1000));
    return () => clearInterval(timer);
  }, [countdownOver, countdownPaused]);
  useEffect(() => {
    !countdownPaused &&
      countdownAnimation > 0 &&
      (timerr = setInterval(
        () => setCountdownAnimation(countdownAnimation - 1),
        100
      ));
    return () => clearInterval(timerr);
  }, [countdownAnimation, countdownPaused]);

  useEffect(() => {
    if (countdownAnimation === 0) {
      props.gameCode === "LTS" && _.isEmpty(props.remainingQuestions)
        ? props.onfinishingBulkQuestions()
        : props.onPlayAgain();
    }
  }, [countdownAnimation]);

  const timeVariants = {
    hidden: { scale: 0.7 },
    visible: {
      scale: 1,
      transition: {
        duration: 0.5,
        repeat: Infinity,
        repeatType: "reverse",
      },
    },
    exit: { scale: 0 },
  };
  const sortedOtherWinnersUserData = [...props.otherWinnersUserData].sort(
    (a, b) => a.answer_time - b.answer_time
  );

  return (
    <>
      <div
        className={cx("text-center sbs-width", {
          zeroOtherCorrectGuessers: props.otherWinnersUserData.length === 0,
        })}
      >
        {props.gameCode === "LT" && !top_logo ? (
          <h2 className="heading">
            Lightning <img src={lightingImg} className="lighting-img" alt="" />{" "}
            Trivia
          </h2>
        ) : props.gameCode === "LTS" ? (
          <></>
        ) : (
          <img src={ltGlobalLogo} className="ltGlobalLogo" alt="ltGlobalLogo" />
        )}
        {props.gameCode === "LTS" && (
          <img src={triviaSubmit} className="lt-logo-inner" alt="" />
        )}
        <Row className="justify-content-center">
          <Col lg={12} xl={12}>
            <div className="que-ans-box">
              <h2 className="question">{lt_Question}</h2>
              <h3 className="answer-txt">The correct answer is:</h3>
              <Button className="answer">{correct_answer}</Button>
            </div>
          </Col>
        </Row>

        {props?.winnerUserData && props?.winnerUserData.length === 0 && (
          <div className="wrong-ans-box">
            <h4>No one got it right!</h4>
            <p>Better luck next time!</p>
            <img src={sadfaceIcon} className="emoji" alt="" />
          </div>
        )}

        {props?.winnerUserData && props?.winnerUserData.length === 1 && (
          <>
            <div className="single-fastest-guesser">
              <div className="single-img-wrap">
                <img
                  src={
                    props.winnerUserData[0]?.profile_image !== "profileImage"
                      ? props.winnerUserData[0]?.profile_image
                      : dummyAvatar
                  }
                  alt=""
                />
                <img src={img100} className="img100" alt="" />
              </div>
              <div className="single-info">
                <p className="fastest">Fastest Guesser:</p>
                <h3 className="name">{props.winnerUserData[0].display_name}</h3>
                <p className="sec">{props.min_seconds} Seconds!</p>
              </div>
            </div>

            <div className="other-guessers">
              <p className="other">Other Correct Guessers:</p>
              <div className="other-guessers-height">
                <div className="other-guessers-flex">
                  {sortedOtherWinnersUserData &&
                    sortedOtherWinnersUserData?.length > 0 &&
                    sortedOtherWinnersUserData?.map((user) => (
                      <div className="guesser">
                        <div className="guesser-info">
                          <img src={user?.profile_image} alt="" />
                          <p className="player">{user.display_name}</p>
                        </div>
                        <div className="position-relative">
                          <div className="d-flex align-items-center">
                            <div className="mr-2">
                              <p className="in-sec">
                                {user.answer_time || "10"}
                              </p>
                              <p className="txt">Sec</p>
                            </div>

                            <p className="inc-num">
                              +{" "}
                              {Math.max(
                                0,
                                75 - 5 * (user?.answer_time - props.min_seconds)
                              ) || 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </>
          // <div>
          //   <p className="fastest">Fastest Guesser:</p>
          //   <h3 className="name">{props.winnerUserData[0].display_name}</h3>
          //   <p className="sec">{props.min_seconds} Sec!</p>
          //   <p className="other">Other Correct Guessers:</p>
          //   <div className="other-guessers">
          //     {props.otherWinnersUserData &&
          //       props?.otherWinnersUserData?.length > 0 &&
          //       props?.otherWinnersUserData?.map((user) => (
          //         <div className="guesser">
          //           <p className="player">{user.display_name}</p>
          //           <p className="in-sec">{user.answer_time || "10"} Sec</p>
          //         </div>
          //       ))}
          //   </div>
          // </div>
        )}

        {props.winnerUserData && props.winnerUserData.length > 1 && (
          <Row className="both-guesser justify-content-center">
            <Col md={12} lg={12}>
              <div className="fastest-guesser-wrap">
                <div className="fastest-guesser-text">
                  <p className="txt">Fastest Guessers:</p>
                  <p className="sec">{props?.min_seconds} seconds!</p>
                </div>
                <div className="fastest-guesser-list">
                  {props.winnerUserData &&
                    props.winnerUserData.length > 0 &&
                    props.winnerUserData.map((user) => (
                      <div className="fastest-guesser">
                        <div className="d-flex align-items-center">
                          <img
                            className="user-img"
                            src={
                              user?.profile_image !== "profileImage"
                                ? user?.profile_image
                                : dummyAvatar
                            }
                            alt=""
                          />
                          <p className="name">{user.display_name}</p>
                        </div>
                        {/* <p className="sec">{props?.min_seconds} Sec</p> */}
                        <img src={img100} className="img100" alt="" />
                      </div>
                    ))}
                </div>
              </div>
            </Col>
            <Col md={12} lg={12}>
              <div className="other-guessers">
                <p className="other">Other Correct Guessers:</p>
                <div className="other-guessers-height">
                  <div className="other-guessers-flex">
                    {props.otherWinnersUserData &&
                      props?.otherWinnersUserData?.length > 0 &&
                      props?.otherWinnersUserData?.map((user) => (
                        <div className="guesser">
                          <div className="guesser-info">
                            <img
                              src={
                                user?.profile_image !== "profileImage"
                                  ? user?.profile_image
                                  : dummyAvatar
                              }
                              alt=""
                            />
                            <p className="player">{user.display_name}</p>
                          </div>
                          <div className="position-relative">
                            <div className="d-flex align-items-center">
                              <div className="mr-2">
                                <p className="in-sec">
                                  {user.answer_time || "10"}
                                </p>
                                <p className="txt">Sec</p>
                              </div>
                              <img src={img75} className="img75" alt="" />
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* <h6>Other Correct Guessers:</h6>
              <div className="fastest-guesser-wrap">
                {props.otherWinnersUserData &&
                  props.otherWinnersUserData.length > 0 &&
                  props.otherWinnersUserData.map((user) => (
                    <div className="fastest-guesser">
                      <p className="name">{user.display_name}</p>
                      <p className="sec">
                        {user?.answer_time || "10-sec"} Sec{" "}
                      </p>
                    </div>
                  ))}
              </div> */}
            </Col>
          </Row>
        )}
        {/* 
        {props.sub_game_code === "LT" && (
          <div className="btn-container">
            <Button onClick={props.onHomeBtn} className="home-btn">
              Home
            </Button>
            <Button
              disabled={props.remainingQuestions?.length === 0}
              onClick={props.onPlayAgain}
              className="again-btn"
            >
              Play Again?
            </Button>
          </div>
        )} */}
        {/* {props.sub_game_code === "LTS" && (
          <div className="btn-container">
            <Button onClick={props.onHomeBtn} className="home-btn">
              Home
            </Button>
            <Button onClick={props.onStartOver} className="home-btn">
              Start Over
            </Button>
            <Button
              disabled={props.remainingQuestions.length === 0}
              onClick={props.onPlayAgain}
              className="again-btn"
            >
              Next Question ({props.remainingQuestions.length})
            </Button>
          </div>
        )} */}
        <div className="horizontal-progress-container">
          <h4 className="title">Next question in:</h4>
          <div className="horizontal-progress-flex">
            <Button
              onClick={() => {
                setCountdownPaused(!countdownPaused);
              }}
            >
              {countdownPaused ? (
                <img
                  // src={countdownPaused ? { playIcon } : { pasueIcon }}
                  src={playIcon}
                  className="icon"
                  alt=""
                />
              ) : (
                <img
                  // src={countdownPaused ? { playIcon } : { pasueIcon }}
                  src={pasueIcon}
                  className="icon"
                  alt=""
                />
              )}
            </Button>
            <div
              className={`horizontal-progress ${
                countdownPaused && "timerPaused"
              }`}
            >
              <div
                style={{ width: `${countdownAnimation}%` }}
                className={cx("progress-value", {
                  paused: countdownPaused,
                })}
              >
                {!countdownPaused && (
                  <>
                    <div className="progress-time">
                      <motion.p className="time" variants={timeVariants}>
                        {/* {countdownOver} */}
                        {Math.ceil(countdownAnimation / 10)}
                      </motion.p>
                      <motion.p className="sec">SEC</motion.p>
                    </div>
                  </>
                )}
              </div>
            </div>
            {countdownPaused && <p className="pause-txt">Paused</p>}
            <Button
              onClick={
                props.gameCode === "LTS" && _.isEmpty(props.remainingQuestions)
                  ? props.onfinishingBulkQuestions
                  : props.onPlayAgain
              }
            >
              <img alt="" src={nextIcon} className="icon" />
            </Button>
          </div>
        </div>
      </div>
      <LeaderBoard />
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withRouter, connect(mapStateToProps))(LtOver);
